export function nfseRpsReducer(state = {rps_nat_opt: 1, type: 1}, action) {
    switch (action.type) {
        case "SET_NFSE_RPS": return action.payload
        default: return state
    }
}
export function nfseTakerReducer(state = {}, action) {
    switch (action.type) {
        case "SET_NFSE_TAKER": return action.payload
        default: return state
    }
}
export function nfseServiceReducer(state = {}, action) {
    switch (action.type) {
        case "SET_NFSE_SERVICE": return action.payload
        default: return state
    }
}
export function nfseItemsReducer(state = [], action) {
    switch (action.type) {
        case "SET_NFSE_ITEMS": return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/nfse/reducers.js